<template>
  <WidgetWrapper v-bind="model" @ready="ready">
    <v-sheet class="d-flex align-center rounded-pill pa-0 pl-2 pr-1 mt-n1 mr-n1">
      <!-- Map Tools -->
      <div class="d-flex align-center">
        <v-btn icon class="ma-1" elevation="0" href="/">
          <v-icon>mdi-home</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t('common.concepts.home') }}
          </v-tooltip>
        </v-btn>

        <v-btn icon class="ma-1" elevation="0" @click="emits('showMapLegend')">
          <v-icon>mdi-map</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t('common.concepts.legend') }}
          </v-tooltip>
        </v-btn>

        <KGoToExtent v-if="initialExtent" id="initialExtent" :extent="initialExtent" elevation="0" />

        <!-- <v-btn icon class="ma-1" @click="showMapSwipe = !showMapSwipe" elevation="0">
          <v-icon>mdi-select-compare</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t("views.toolsToc.swipe") }}
          </v-tooltip>
        </v-btn> -->

        <KMeasure
          :v-btn-props="{
            icon: 'mdi-ruler',
            class: 'ma-1',
            elevation: 0
          }"
          units="Imperial System">
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t('views.toolsToc.measurements') }}
          </v-tooltip>
        </KMeasure>

        <KMyPosition>
          <v-icon>mdi-crosshairs-gps</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t('views.toolsToc.geolocation') }}
          </v-tooltip>
        </KMyPosition>

        <v-btn icon class="ma-1" elevation="0" @click="showDashboard">
          <v-icon>mdi-chart-box</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t('common.concepts.dashboard') }}
          </v-tooltip>
        </v-btn>

        <!-- <v-btn icon class="ma-1" @click="showFilters" elevation="0">
          <v-icon>mdi-tune</v-icon>
          <v-tooltip activator="parent" location="bottom" content-class="custom-tooltip" open-delay="1000">
            {{ $t("common.concepts.filters") }}
          </v-tooltip>
        </v-btn> -->
      </div>

      <v-btn icon color="white" class="ma-1 bg-primary" data-testid="user-menu-button">
        <v-icon v-if="!user">mdi-lock</v-icon>
        <span v-else>{{ userInitials }}</span>
        <v-menu activator="parent" location="bottom" class="mt-2" :close-on-content-click="false">
          <UserMenu />
        </v-menu>
      </v-btn>
    </v-sheet>
  </WidgetWrapper>

  <KSwipe v-show="showMapSwipe"></KSwipe>
</template>

<script setup lang="ts">
import { shallowRef, ref, watch } from 'vue'

import AuthStore from '@/stores/auth'

import { storeToRefs } from 'pinia'

// settings
import type { ExtentCommon } from '@tsyl/karonte/lib/types/view'
import type { WidgetBuilder } from '@tsyl/karonte/lib/types/widgets'

const model = defineProps({
  ...BasicWidgetProps,
  initialExtent: {
    type: Object as () => ExtentCommon,
    required: false
  }
})

const emits = defineEmits<{
  (event: 'showMapLegend'): void
}>()

const enableWidgets = ref(false)
const widgetBuilderRef = shallowRef<WidgetBuilder | undefined>()

const ready = async (widgetBuilder: WidgetBuilder) => {
  await widgetBuilder.waitReady()
  enableWidgets.value = true
  widgetBuilderRef.value = widgetBuilder
}

const showMapSwipe = ref(false)

// Auth imports
const auth = AuthStore()
const { user } = storeToRefs(auth)
const userInitials = ref('--')

// Translator import
import BasicWidgetProps from '@tsyl/karonte/lib/widgets/BasicWidgetProps'
import { WidgetWrapper } from '@tsyl/karonte-widgets'

import UserMenu from '@/components/User/UserMenu.vue'
import router from '@/router'
function showDashboard() {
  router.push({ name: 'dashboard' })
}

watch(
  user,
  () => {
    if (!user.value) return
    if (user.value.name)
      userInitials.value = user.value.name
        .split(' ')
        .map((n) => n.charAt(0))
        .join('')
    else userInitials.value = user.value?.firstName?.charAt(0) + '' + user.value?.lastName?.charAt(0)
  },
  {
    immediate: true
  }
)
</script>

<style scoped lang="scss">
.elevation_ramp::v-deep(.ramp-column) {
  height: 300px !important;
}

/*
.test::v-deep(.ramp-labels) {
  font-size: 2px !important;
}

.test::v-deep(.ramp-label) {
  font-size: 16px !important;
}
*/
</style>
